import { render, staticRenderFns } from "./CaseReasons.vue?vue&type=template&id=0c8c6cb6&"
import script from "./CaseReasons.vue?vue&type=script&lang=js&"
export * from "./CaseReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports